export const CASES = {
    UPDATE_USERS: 'UPDATE_USERS',
    CLEAR_USERS: 'CLEAR_USERS',
};
